import { Link } from 'react-router-dom';
import MatchCard from '@/components/feature/MatchCard';
import { matches, sortByTime } from '@/lib/site';

const tabs = [
  { key: 'all', label: '全部赛事' },
  { key: 'live', label: '直播中' },
  { key: 'upcoming', label: '即将开始' },
];

interface LatestMatchesProps {
  active: string;
  onChange: (key: string) => void;
}

export default function LatestMatches({ active, onChange }: LatestMatchesProps) {
  const list = sortByTime(matches).filter((item) => (active === 'all' ? true : item.status === active));

  return (
    <section aria-labelledby="latest-matches" className="w-full">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-4">
        <div>
          <p className="font-heading text-[11px] tracking-[0.28em] text-accent-600 mb-1">LATEST</p>
          <h2 id="latest-matches" className="font-heading text-xl md:text-2xl text-foreground-950">
            最新赛事列表
          </h2>
        </div>
        <div className="inline-flex items-center gap-1 rounded-full bg-background-200 p-1 self-start sm:self-auto">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => onChange(tab.key)}
              className={`px-3.5 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors cursor-pointer ${
                active === tab.key
                  ? 'bg-background-50 text-foreground-950 font-medium'
                  : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 md:gap-4">
        {list.map((match) => (
          <MatchCard key={match.id} match={match} />
        ))}
      </div>

      {list.length === 0 && (
        <div className="rounded-lg bg-background-50 border border-background-200 py-12 text-center">
          <i className="ri-calendar-close-line text-2xl text-foreground-400" />
          <p className="mt-2 text-sm text-foreground-600">该分类下暂无赛事，切换其他标签试试</p>
        </div>
      )}

      <div className="mt-5 flex justify-center">
        <Link
          to="/category/nba"
          className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          浏览全部分类
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}